const styles = theme => ({
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
    '& > .MuiButton-root': {
      marginBottom: theme.spacing(1),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginBottom: 0,
        maxWidth: '250px',
      },
    },
  },
})

export default styles
